import { Page } from '@/components/layout/page/page.tsx'
import { MessageHistoryTable } from '@/modules/log-of-all-messages/components/message-history-table.tsx'

export const MessageHistoryPage = () => {
  return (
    <Page
      title="Message History"
      description="Read all messages that have been sent out on OnlyFans"
    >
      <MessageHistoryTable />
    </Page>
  )
}
